import type { RootState } from '@/stores/store'

import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface HubServerState {
  // Maps customerId -> selected IP address
  selectedHubServerByCustomer: Record<string, string>
}

const initialState: HubServerState = {
  selectedHubServerByCustomer: {}
}

const hubServerSlice = createSlice({
  name: 'hubServer',
  initialState,
  reducers: {
    setSelectedHubServer(
      state,
      action: PayloadAction<{ customerId: string; ipAddress: string }>
    ) {
      state.selectedHubServerByCustomer[action.payload.customerId] =
        action.payload.ipAddress
    }
  }
})

export const { setSelectedHubServer } = hubServerSlice.actions

export const hubServerReducer = hubServerSlice.reducer

// Selectors
export const selectHubServerIp = (state: RootState, customerId: string) =>
  state.hubServer?.selectedHubServerByCustomer?.[customerId]
